import { NotificationStore } from './NotificationStore';

export const notificationStore = new NotificationStore();
